<div class="alias-lists maximized-component">
    <div class="grids-container">
        <div id="alias-lists-section">
            <res-generic-grid [gridName]="gridName" [automationId]="automationId" [helpIndex]="helpIndex"
                [headerTemplate]="headerTemplate" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
                [columnDefs]="columnDefs" [requestInfo]="requestInfo" [contextMenuOptions]="contextMenuOptions"
                [responseCallback]="responseCallback" [rowSelection]="aliasListSelection"
                [cellDoubleClickedCallback]="cellDoubleClickedCallback" [pagerVisible]="false"
                [onSelectionChanged]="onSelectionChanged" [loadDataFinishedCallback]="loadDataFinishedCallback"
                [updateStatusType]="updateStatusType">
            </res-generic-grid>
            <ng-template #headerTemplate>
                <div class='parent-header'>
                    <span>Alias Lists</span>
                    <button type="button" data-automation-id="alias-lists-add-new-alias-list-button"
                        class="secondary-button" (click)="addNewAliasList()" *ngIf="hasALCreatePermissions">
                        <i class="fa fa-plus"></i>New Alias List ...
                    </button>
                </div>
            </ng-template>
        </div>
        <res-resizer [attr.data-automation-id]="'alias-lists-resizer'" anchor="left"
            resizingElementId="alias-lists-section" secondElementId="aliases-section" [usePercentages]="true"
            [initSize]="60" [minSize]="20" [maxSize]="80" [ellipsisExpander]="true"></res-resizer>
        <div id="aliases-section">
            <res-generic-grid [automationId]="aliasesAutomationId" [rowSelection]="aliasesSelection"
                [pagerVisible]="false" [columnDefs]="colDefsAliases" [headerTemplate]="aliasesHeaderTemplate"
                [onSelectionChanged]="countSelectedAliases" [gridContext]="gridContext"
                [onCustomFilterCallback]="onCustomFilterCallback" [rowClassRules]="rowClassRules">
            </res-generic-grid>
            <ng-template #aliasesHeaderTemplate>
                <div class='parent-header'>
                    <span>Aliases</span>
                    <button type="button" data-automation-id="alias-entries-add-aliases-button" class="secondary-button"
                        (click)="addAliases()" [disabled]="numberOfAliasLists === 0" *ngIf="hasALCreatePermissions">
                        <i class="fa fa-plus sizing-icons"></i>Add Aliases ...</button>
                    <div class='grid-row-delete'>
                        <span (click)="deleteSelectedAliases()"
                            [ngClass]="[numberOfSelectedAliases > 0 ? 'enabled-class' : 'disabled-class']"
                            data-automation-id="alias-entries-delete-selected-button" *ngIf="hasALCreatePermissions">
                            <i class="fa fa-trash sizing-icons"></i>Delete Selected</span>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>